import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import TeslaButton from '../../components/common/TeslaButton';
import { getBaseUrl } from '../../config/api';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setError('Please enter your email address');
      return;
    }
    
    try {
      setIsSubmitting(true);
      setError(null);

      const response = await fetch(`${getBaseUrl()}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase() })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to send reset email');
      }

      setSubmitSuccess(true);
      setIsSubmitting(false);
    } catch (err: any) {
      setError(err.message || 'Failed to send reset password email');
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-layout">
      <div className="auth-card" style={{ maxWidth: '500px' }}>
        <div className="auth-card__content">
          <h2 className="auth-card__form-title">Forgot Password</h2>
          
          {submitSuccess ? (
            <div>
              <div className="alert alert--success mb-6">
                If an account exists with that email, we've sent you instructions to reset your password.
              </div>
              <TeslaButton
                variant="primary"
                fullWidth
                onClick={() => navigate('/login')}
              >
                Return to Login
              </TeslaButton>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="auth-form">
              <p className="mb-6 text-gray-60">
                Enter the email address associated with your account, and we'll send you a link to reset your password.
              </p>
              
              {error && (
                <div className="alert alert--error mb-6">
                  {error}
                </div>
              )}
              
              <div className="auth-form__group">
                <label htmlFor="email" className="auth-form__label">
                  Email Address
                </label>
                <input
                  id="email"
                  type="email"
                  className="auth-form__input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isSubmitting}
                  required
                />
              </div>
              
              <TeslaButton
                type="submit"
                variant="primary"
                fullWidth
                disabled={isSubmitting}
                loading={isSubmitting}
                className="auth-form__submit"
              >
                Reset Password
              </TeslaButton>
              
              <div className="auth-form__footer">
                Remember your password? <Link to="/login">Sign In</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;